
// <!-- 产品 产品-批量导入 -->
export const productGuidInList = [

  {
    label: '*品类',
    prop: 'pcName'
  },
  {
    label: '*品牌',
    prop: 'brandName'
  },
  {
    label: '*系列',
    prop: 'seriesName'
  },
  {
    label: '*产品名称',
    prop: 'proName',
    width: '100'
  },
  {
    label: '型号',
    prop: 'proModel'
  },
  {
    label: '订货号',
    prop: 'proOrdernum'
  },
  {
    label: '型号别称',
    prop: 'proModelnick'
  },
  {
    label: '*产品面价',
    width: '100',
    prop: 'proPrice'
  }, {
    label: '*最小单位',
    prop: 'proUnit',
    width: '100'
  },
  {
    label: '属地',
    prop: 'proTerritory'
  },
  {
    label: '是否停产',
    prop: 'isStop'
  }

]
// <!-- 品牌价格系数 产品-品牌系数导出导入 -->
export const productGuidBrandList = [
  {
    label: '品牌名称',
    prop: 'brandName'
  },
  {
    label: '品牌系数',
    prop: 'brandCoefficient',
    render: true
  }
]
// <!-- 系列价格系数 产品-系列系数导出导入 -->
export const productGuidSericeList = [
  {
    label: '品牌名称',
    prop: 'brandName'
  },
  {
    label: '系列名称',
    prop: 'seriesName'
  },

  {
    label: '系列系数',
    prop: 'seriesCoefficient',
    render: true
  }
]
// <!-- 单品价格系数 产品-型号系数导出导入 -->
export const productGuidProList = [
  {
    label: '品牌名称',
    prop: 'brandName'
  },
  {
    label: '系列名称',
    prop: 'seriesName'
  },
  {
    label: '型号名称',
    prop: 'proModel'
  },

  {
    label: '型号系数',
    prop: 'proCoefficient',
    render: true
  }
]
// <!-- 客户-批量导入 -->
export const clientGuidInList = [
  {
    label: '*客户名称',
    prop: 'cusName'
  },
  {
    label: '*联系人',
    prop: 'ccContacts'
  },
  {
    label: '*联系电话',
    prop: 'ccPhone'
  },
  {
    label: '联系手机',
    prop: 'ccMobile'
  }
]

// <!-- 采购询价 -->
export const purchaseGuidInList = [
  {
    label: '询价单编号',
    prop: 'omiId',
    width: '100'
  },
  {
    label: '品类',
    prop: 'pcName'
  },
  {
    label: '品牌',
    prop: 'brandName'
  },
  {
    label: '系列',
    prop: 'seriesName'
  },
  {
    label: '产品名称',
    prop: 'proName'
  },
  {
    label: '型号',
    prop: 'proType'
  },
  {
    label: '订货号',
    prop: 'orderNumber'
  },
  {
    label: '货期（天）',
    prop: 'ocExtime',
    width: 120
  },
  {
    label: '数量',
    prop: 'ocNeednumber'
  },
  {
    label: '供应商名称',
    prop: 'suName',
    width: 120
  },
  {
    label: '单品报价',
    prop: 'ocPrice'
  },
  {
    label: '价格有效期',
    prop: 'ocExdate',
    width: 120
  }
]

// 采购产品清单-导出产品
export const purchasePlanGuidList = [
  {
    label: '*工单编号',
    prop: 'ocspCode',
    width: '100'
  },
  {
    label: '*备货方式',
    prop: 'stockupType'
  },
  {
    label: '*品牌',
    prop: 'brandName'
  },
  {
    label: '*型号',
    prop: 'proType'
  },

  {
    label: '*订货号',
    prop: 'orderNumber'
  },
  {
    label: '*货期',
    prop: 'cbExtimeValue',
    width: 120
  },
  {
    label: '*数量',
    prop: 'stockupCount'
  },
  {
    label: '采购单价',
    prop: 'cbPrice',
    width: 120
  },
  {
    label: '采购总额',
    prop: 'cbTotal'
  },
  {
    label: '*发起人',
    prop: 'createUser',
    width: 120
  },
  {
    label: '*询价来源',
    prop: 'cbPriceSource',
    width: 120
  }
]

// 生成合同（采购生成）-导入产品
export const productInformationGuidList = [
  {
    label: '*品牌',
    prop: 'brandName',
    width: '100'
  },
  {
    label: '型号',
    prop: 'proType'
  },
  {
    label: '订货号',
    prop: 'orderNumber'
  },
  {
    label: '数量',
    prop: 'proCount'
  },
  {
    label: '类型',
    prop: 'proExtype',
    width: 120
  },

  {
    label: '货期',
    prop: 'ocExtime',
    width: 120
  }
]

// <!-- 仓储-货架管理批量新增 -->
export const storgeGuidInList = [
  {
    label: '仓库',
    prop: 'storageName'
  },
  {
    label: '货架名称',
    prop: 'shelvesName'
  }

]
// <!-- 仓库期初库存 -->
export const openingInventoryGuidList = [
  {
    label: '*仓库',
    prop: 'storageName'
  },
  {
    label: '*货架',
    prop: 'shelvesName'
  },
  {
    label: '*产品品牌',
    prop: 'brandName'
  },
  {
    label: '型号',
    prop: 'proModel'
  },
  {
    label: '订货号',
    prop: 'proOrdernum'
  },
  {
    label: '*期初库存',
    prop: 'count'
  },
  {
    label: '*采购单价',
    prop: 'unitPrice'
  },
  {
    label: '*产品序列号',
    prop: 'serialNumber'
  }

]
